module.exports = __webpack_public_path__ + "img/image54.31658ff6.png";